import { Field } from '@k2/common/k2-forms-state/types';

export function booleanFormatter(field: Field): string {
  return field.control.value === true ? 'Yes' : 'No';
}
